module.exports = require("make-plural/plurals");